var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2508 6.75H13C12.5858 6.75 12.25 6.41421 12.25 6C12.25 5.58579 12.5858 5.25 13 5.25H18C18.0054 5.25 18.0109 5.25006 18.0163 5.25017C18.4235 5.25836 18.751 5.59104 18.7509 6.00016L18.75 11.0002C18.7499 11.4144 18.4141 11.7501 17.9998 11.75C17.5856 11.7499 17.2499 11.4141 17.25 10.9999L17.2508 6.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 13C6.75 12.5858 6.41421 12.25 6 12.25C5.58579 12.25 5.25 12.5858 5.25 13V18C5.25 18.4142 5.58579 18.75 6 18.75H11C11.4142 18.75 11.75 18.4142 11.75 18C11.75 17.5858 11.4142 17.25 11 17.25H6.75V13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3C2.25 2.58579 2.58579 2.25 3 2.25H9C9.41421 2.25 9.75 2.58579 9.75 3V9C9.75 9.41421 9.41421 9.75 9 9.75H3C2.58579 9.75 2.25 9.41421 2.25 9V3ZM3.75 3.75V8.25H8.25V3.75H3.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 15C14.25 14.5858 14.5858 14.25 15 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15V21C21.75 21.4142 21.4142 21.75 21 21.75H15C14.5858 21.75 14.25 21.4142 14.25 21V15ZM15.75 15.75V20.25H20.25V15.75H15.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSwap);
export default __webpack_public_path__ + "static/media/image-swap.fbf32cb77e9fffe33471141ead66baa0.svg";
export { ForwardRef as ReactComponent };